import { Link } from "react-router-dom";
import { useClock } from "@/hooks/useClock";
import type { ReactNode } from "react";

interface TaskbarProps {
  variant: "landing" | "tutor";
  children?: ReactNode;
  /** Destino do botão "← Voltar" (apenas variant=tutor). Default "/". */
  backTo?: string;
}

export default function Taskbar({ variant, children, backTo = "/" }: TaskbarProps) {
  const time = useClock();

  if (variant === "tutor") {
    return (
      <nav className="taskbar-tutor">
        <Link to={backTo} className="back-btn">
          ← Voltar
        </Link>
        <div className="taskbar-tutor-center">
          <span className="bulb">💡</span>
          <span className="taskbar-tutor-title">PRO_GRAMMING - TUTOR</span>
        </div>
        <div className="taskbar-right">
          {children}
          <span className="clock">{time}</span>
        </div>
      </nav>
    );
  }

  return (
    <nav className="taskbar">
      <Link to="/" className="taskbar-logo">
        <img src="/Logo2.png" alt="PRO_GRAMMING logo" />
        <span className="taskbar-logo-text">PRO_GRAMMING</span>
      </Link>

      <div className="nav-links">
        <Link to="/#sobre">Sobre</Link>
        <Link to="/#edicoes">Edições</Link>
        <Link to="/#membros">Membros</Link>
        <Link to="/batalhadebits" className="nav-battle-link">Batalha</Link>
        <Link to="/tutor" className="tutor-btn">
          TUTOR ONLINE
        </Link>
      </div>

      <div className="taskbar-right">
        {children}
        <span className="taskbar-clock">{time}</span>
      </div>
    </nav>
  );
}
